export function GoalGauge({ ratio, size = 168, testid = "goal-gauge" }) {
  const r = Math.max(0, Math.min(ratio || 0, 1.25));
  const pctShown = Math.round((ratio || 0) * 100);
  const angle = Math.PI * Math.min(r / 1.25, 1);
  const cx = size / 2, cy = size / 2, rad = size / 2 - 12;
  const x = cx - rad * Math.cos(angle), y = cy - rad * Math.sin(angle);
  const on = ratio >= 1;
  const color = on ? "#10B981" : ratio >= 0.8 ? "#F59E0B" : "#F43F5E";
  const goalAngle = Math.PI * (1 / 1.25);
  const gx = cx - rad * Math.cos(goalAngle), gy = cy - rad * Math.sin(goalAngle);
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <svg width={size} height={size / 2 + 14} viewBox={`0 0 ${size} ${size / 2 + 14}`}>
        <path d={`M 12 ${cy} A ${rad} ${rad} 0 0 1 ${size - 12} ${cy}`} fill="none" stroke="currentColor" className="text-slate-200 dark:text-slate-800" strokeWidth="12" strokeLinecap="round" />
        <path d={`M 12 ${cy} A ${rad} ${rad} 0 0 1 ${x} ${y}`} fill="none" stroke={color} strokeWidth="12" strokeLinecap="round" style={{ transition: "stroke 300ms ease-out" }} />
        <circle cx={gx} cy={gy} r="3.5" className="fill-slate-900 dark:fill-white" />
      </svg>
      <div className="-mt-9 text-center">
        <p className="font-mono-num text-2xl font-semibold text-slate-900 dark:text-white" data-testid={`${testid}-pct`}>{pctShown}%</p>
        <p className={`text-xs font-medium ${on ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`} data-testid={`${testid}-status`}>{on ? "On Track" : "Off Track"}</p>
      </div>
    </div>
  );
}
